// extracted by mini-css-extract-plugin
export var linkCardBoxShadow = "LinkCard-module--link-card-box-shadow--2aZ1B";
export var linkCardHover = "LinkCard-module--link-card-hover--xNrGj";